<div class="container-fluid padding-lg-top padding-xl-bottom">
    <div class="container">
        <app-resource resourceIdentifier="Case%20Studies/{{resourceIdentifier}}" [showActions]="false"></app-resource>
    </div>
</div>